// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"83e7fc28","729":"7cea2ec1"}[chunkId] + ".chunk.js";
};